document.addEventListener('DOMContentLoaded', function() {
  function initTabsHeaderSlider(selector) {
    const swiperSlider = document.querySelectorAll(selector);

    swiperSlider.forEach(function (swiperEl) {
      const swiperGallery = new Swiper(swiperEl, {
        slidesPerView: "auto",
        spaceBetween: 0,
        direction: "horizontal",
        loop: false,
        navigation: {
          nextEl: swiperEl.closest('._js-block-tab-container').querySelector("._js-block-tab-slider-arrows-next"),
          prevEl: swiperEl.closest('._js-block-tab-container').querySelector("._js-block-tab-slider-arrows-prev"),
        },
        on: {
          click: function(swiper, event) {
            const clickedIndex = swiper.clickedIndex;
            swiper.slideTo(clickedIndex);
          },
          fromEdge: function (swiper) {
            if (!swiper.isBeginning) {
              swiper.el.classList.add('_before');
            }
            if (!swiper.isEnd) {
              swiper.el.classList.add('_after');
            }
          },
          reachBeginning: function (swiper) {
            swiper.el.classList.remove('_before');
          },
          reachEnd: function (swiper) {
            swiper.el.classList.remove('_after');
          },
        },
      });
    });
  }
  function initTabs() {
    const tabContainers = document.querySelectorAll('._js-block-tab-container');
    tabContainers.forEach((containerItem, containerIndex) => {
      let tabs = containerItem.querySelectorAll('._js-block-tabs-title');
      let tabsContent = containerItem.querySelectorAll('._js-block-tabs-content');
      tabs.forEach((item, index) => {
        item.addEventListener('click', () => {
          tabs.forEach(el => el.classList.remove('_active'));
          tabsContent.forEach(el => el.classList.remove('_active'));

          item.classList.add('_active');
          tabsContent[index].classList.add('_active');
        })
      })
    });

  }

  initTabsHeaderSlider("._js-block-tab-slider");
  initTabs();
});
